import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=d4fab994&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=d4fab994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fab994",
  null
  
)

/* custom blocks */
import block0 from "./Question.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4fab994')) {
      api.createRecord('d4fab994', component.options)
    } else {
      api.reload('d4fab994', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=d4fab994&scoped=true&", function () {
      api.rerender('d4fab994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-analysis/Question.vue"
export default component.exports